<template>
  <div class="banner">
    <div class="banner-inner">
      <template v-if="banner.background">
        <div class="background">
          <img :src="`${api_url}${banner.background.url}`"
               :alt="banner.background.alternativeText"
               :title="banner.background.alternativeText"
               :key="banner.background.id"/>
        </div>
      </template>

      <div class="container">
        <div class="text">
          <h1 class="animate__fadeInUp" v-observe-visibility="{ callback: animate, once: true }">{{ banner.title }}</h1>
          <div class="animate__fadeInUp" v-observe-visibility="{ callback: animate, once: true }" v-html="banner.description"></div>
        </div>
      </div>

      <template v-if="banner.portrait">
        <div class="portrait">
          <img v-observe-visibility="{ callback: animate, once: true }"
               class="animate__fadeInRight"
               :src="`${api_url}${banner.portrait.url}`"
               :alt="banner.portrait.alternativeText"
               :title="banner.portrait.alternativeText"
               :key="banner.portrait.id"/>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'banner',
  data: function() {
    return {
      api_url: process.env.VUE_APP_STRAPI_API_URL
    };
  },
  props: {
    banner: {
      type: Object,
    },
  },
  methods: {
    animate(isVisible, entry) {
      if (isVisible) {
        entry.target.classList.add('animate__animated');
      }
    },
  },
};
</script>
